import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UserLocationState } from '../store/user-location.state';
import { DefaultProjectState } from '../store/default-project.state';
import { Language } from './language.provider';
import { UrlBuilder } from '../utils/url-builder';

enum ApiEndpoint {
  BookLanguage = '/books/languages',
}

/**
 * This file has been created to avoid circular dependency injection between books.provider.ts <-> user-location.state.ts
 */
@Injectable({ providedIn: 'root' })
export class BookLanguageProvider {
  constructor(
    private http: HttpClient,
    private userLocationState: UserLocationState,
    private defaultProjectState: DefaultProjectState,
  ) {}

  getBookLanguages(): Observable<Language[]> {
    const url = new UrlBuilder(ApiEndpoint.BookLanguage)
      .setQueryParams({
        project_id: this.defaultProjectState.defaultProject$.value.id,
        country: this.userLocationState.userLocation$.value.countryCode,
      })
      .getUrl();

    return this.http.get<Language[]>(environment.booksBaseUrl + url);
  }
}
